import {
    GetBrandBySlugViewModel,
    GetBrandCategoryViewModel,
    GetCategoryBySlugViewModel,
    GetTagBySlugViewModel,
} from '../../types/api'

export enum PLPPages {
    Combination = '_combination_',
    Brands = 'brands',
    Categories = 'categories',
    Search = 'search',
    Tags = 'tags',
}

export type PurePLPBasicMetasProps =
    | Partial<GetBrandBySlugViewModel>
    | Partial<GetCategoryBySlugViewModel>
    | Partial<GetTagBySlugViewModel>

export type PLPBasicMetasProps = PurePLPBasicMetasProps | GetBrandCategoryViewModel

export interface PLPPageProps {
    params?: { [key: string]: string | string[] | undefined }
    searchParams?: { [key: string]: string | string[] | undefined | null }
}

export interface PLPBannerProps {
    params?: { [key: string]: string | string[] | undefined }
    searchParams?: { [key: string]: string | string[] | undefined | null }
    page?: PLPPages
    basicMetas?: PLPBasicMetasProps
}

export enum PLPReactQueryKeys {
    BasicMeta = 'basic-metas',
    PLPFacets = 'plp-facets',
    PagesData = 'pages-data',
    ProductsCount = 'products-count',
    PriceRange = 'price-range',
    PLPBanner = 'plp-banner',
}

export type PLPSlug = string | [string, string]
